import { render, staticRenderFns } from "./store_purchases_report.vue?vue&type=template&id=58b0d0a0&"
import script from "./store_purchases_report.vue?vue&type=script&lang=js&"
export * from "./store_purchases_report.vue?vue&type=script&lang=js&"
import style0 from "./store_purchases_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports